import '../ApplicationCard/applicationCard.scss';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import VehicleImagePlaceholder from '../../assets/vehicle-placeholder.png';
import { RefandiCardProps } from './types/RefandiCardProps';

export const RefandiCard = ({ testId }: RefandiCardProps): ReactNode => {
  const { t } = useTranslation();

  return (
    <li data-testid={testId}>
      <Card
        className="application-card"
        component={Link}
        raised={false}
        to={'/loan-documents'}
      >
        <figure>
          <CardMedia
            alt={t('DashboardGaragePage.refandi.description')}
            component={'img'}
            image={VehicleImagePlaceholder}
          />
        </figure>
        <CardContent>
          <p className="card-title">
            {t('DashboardGaragePage.refandi.description')}
          </p>
          <p className="card-subtitle">
            {t('DashboardGaragePage.refandi.applicationDescription')}
          </p>
        </CardContent>
      </Card>
    </li>
  );
};
